export default __webpack_public_path__ + "static/media/F_wdt_c_cap_2.ab4981b3.mp3";